import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { userSchema } from "../user";

export const registerSchema = userSchema
  .pick({ name: true, email: true, username: true, locale: true })
  .extend({
    password: z.password().min(6, { message: "Password must be at least 6 characters." }),
    /** Opt-in to marketing emails (drip sequence, updates, etc.) */
    marketingOptIn: z.boolean().optional().default(false),
    /** Invisible reCAPTCHA v3 token */
    recaptchaToken: z.string().optional(),
    /** User must accept terms and privacy policy before registration */
    termsAccepted: z
      .boolean()
      .refine((value) => value, { message: "You must accept the terms to continue." }),
  });

export class RegisterDto extends createZodDto(registerSchema) {}
